import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import {  formatFilterValues } from '@/pages/dashboard/utils/utils';
import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';
import moment from 'moment';

export default function MonetizationRevenueTrendCo(props: any) {
  const { style, className, type, config, children, ...resetProps } = props || {};
  const { api, isSingle = true, dataKey, isSegmentFilter,
    formatParams = (d: unknown) => d,
    formatData = (d: unknown) => d,
  } = config || {};
  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    };
  }, shallowEqual);

  const data = useMemo(() => {
    return {
      gameCode,
      regionDataType: props?.data?.regionDataType
    };
  }, [gameCode, props?.data?.regionDataType]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        beforeRequest={(data) => {
          const {
            filterVal,
            gameCode,
          } = data;
          const { rangeTime,timeType, ...filters } = filterVal;
          const tabNames: any = {
            Day: 'daily',
            Week: 'weekly',
            Month: 'monthly',
          };
          const params: { [key in string]: unknown } = {
            game_code: gameCode,
            start_time: moment(rangeTime?.[0]).format('YYYY-MM-DD'),
            end_time: moment(rangeTime?.[1]).format('YYYY-MM-DD'),
            period: tabNames[timeType] || 'daily',
            filters: formatFilterValues(filters),
          };
          if (isSegmentFilter)
            params.by_type = data?.regionDataType || 'country';
          return stringToFunction(formatParams as any)(params);
        }}
        formatData={formatData}
        trackData={['gameCode','regionDataType']}>
        {React.Children.map(children, (child: any) => {
          return React.cloneElement(
            child,
            {
              ...resetProps,
              tabMsg: props?.data?.tabMsg,
              isSingle,
              state: {
                regionDataType: props?.data?.regionDataType
              }
            }
          );
        })}
      </Service>
    </div>
  );
};
